<template>
    <transition name="imloading-fade">
        <div v-if="visible" class="im-loading-wrap">
            <div class="loading-content" role="status" aria-live="polite">
                <div class="im-spinner" aria-label="加载中">
                    <span class="sr-only">加载中</span>
                    <div class="im-arc a1"></div>
                    <div class="im-arc a2"></div>
                    <div class="im-arc a3"></div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data () {
        return {
            visible: false,
        }
    }
}
</script>
<style lang="less" scoped>
    .im-loading-wrap {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0, 0.2);
        z-index: 2021;
        backdrop-filter: blur(6px);
        -webkit-backdrop-filter: blur(6px);
        transition: backdrop-filter 0.2s ease, background-color 0.2s ease;
        pointer-events: all;
        .loading-content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            animation: imloading-pulse 1s ease-in-out infinite;
        }

        /* 高级：三段色弧线（conic-gradient + radial-mask） */
        .im-spinner {
            --size: 36px;
            --thickness: 6px;
            --c1: #5C6FFE;  /* 主色 */
            --c2: #7A8BFF;  /* 次色 */
            --c3: #9FB0FF;  /* 辅色 */
            width: var(--size);
            height: var(--size);
            position: relative;
            filter: drop-shadow(0 2px 6px rgba(0,0,0,0.25));
            animation: imloading-spin 0.9s linear infinite;
        }
        .im-arc {
            position: absolute;
            inset: 0;
            border-radius: 50%;
            -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - var(--thickness)), #000 calc(100% - var(--thickness)));
            mask: radial-gradient(farthest-side, transparent calc(100% - var(--thickness)), #000 calc(100% - var(--thickness)));
        }
        /* 每个弧线都有轻微渐隐尾巴，观感更自然 */
        .a1 {
            transform: rotate(0deg);
            background: conic-gradient(
                #5C6FFE 0deg 90deg,
                rgba(92,111,254,0) 102deg 360deg
            );
        }
        .a2 {
            transform: rotate(120deg);
            background: conic-gradient(
                #7A8BFF 0deg 90deg,
                rgba(122,139,255,0) 102deg 360deg
            );
        }
        .a3 {
            transform: rotate(240deg);
            background: conic-gradient(
                #9FB0FF 0deg 90deg,
                rgba(159,176,255,0) 102deg 360deg
            );
        }

        /* Fallback：不支持 conic-gradient 的浏览器使用双环边框方案 */
        @supports not (background: conic-gradient(#000, #fff)) {
          .im-spinner {
            width: var(--size);
            height: var(--size);
            border-radius: 50%;
            background: none;
          }
          .im-arc { display: none; }
          .im-spinner::before {
            content: '';
            position: absolute;
            inset: 0;
            border-radius: 50%;
            box-sizing: border-box;
            border: 3px solid rgba(255,255,255,0.28);
          }
          .im-spinner::after {
            content: '';
            position: absolute;
            inset: 0;
            border-radius: 50%;
            box-sizing: border-box;
            border: 3px solid transparent;
            border-top-color: var(--c1);
            border-right-color: var(--c2);
            animation: imloading-spin 0.9s linear infinite;
          }
        }

        /* 无障碍隐藏文本 */
        .sr-only {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            white-space: nowrap;
            border: 0;
        }
    }

    .imloading-fade-enter-active, .imloading-fade-leave-active {
        transition: opacity 0.18s ease;
    }
    .imloading-fade-enter, .imloading-fade-leave-to {
        opacity: 0;
    }

    @keyframes imloading-pulse {
        0% { transform: translate(-50%, -50%) scale(0.96); }
        50% { transform: translate(-50%, -50%) scale(1.04); }
        100% { transform: translate(-50%, -50%) scale(0.96); }
    }
    @keyframes imloading-spin {
        to { transform: rotate(360deg); }
    }
</style>
